import Vue from 'vue'
import axios from 'axios'
import App from './App.vue'
import VueRouter from "vue-router"
import router from "./routes.js"
import "./assets/css/output.css"
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'


import {BootstrapVue, DropdownPlugin, AlertPlugin, IconsPlugin} from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/scss/style.scss'

// VeeValidate
import {ValidationObserver, ValidationProvider} from 'vee-validate'

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
// Rules
require('./rules');


import Swal from 'sweetalert2'

const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  onOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  }
})
Vue.prototype.$toast = Toast

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css'

Vue.component('flat-pickr', flatPickr)


// Install BootstrapVue
Vue.use(BootstrapVue)
Vue.use(DropdownPlugin)
Vue.use(AlertPlugin)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

Vue.use(VueRouter);

Vue.config.productionTip = false

import store from './store'

const host = process.env.VUE_APP_PROXY
const baseUrl = host + '/api/parent'

window.login = function () {
  axios.get('/sanctum/csrf-cookie', {baseURL: host}).then(() => {
    axios.post('/api/login', {login: 'parent', 'password': 'secret'}, {baseURL: host})
      .then(() => window.location = '/')
  })
}

window.logout = function () {
  axios.post('/api/logout', {}, {baseURL: host})
    .then(() => window.location = store.state.home_url)
}


axios.defaults.baseURL = baseUrl
axios.defaults.baseApiUrl = host + '/api'
axios.defaults.withCredentials = true;
Vue.prototype.$axios = axios

axios.get('/data')
  .then(({data}) => {
    store.commit('set_data', data)
    start()
  })

function start() {
  window.$vue = new Vue({
    router,
    store,
    render: h => h(App),
  }).$mount('#app')
}
